/*
 * cart-edit.js v5
 * Robust approach: verify cart state before updating
 */
(function() {
  var params = new URLSearchParams(window.location.search);
  var isEdit = params.get('cart_edit') === 'true';
  var lineKey = params.get('line_key');
  var originalVariantId = params.get('variant');

  /* ---- Auto-open cart drawer on previous page ---- */
  if (sessionStorage.getItem('open_cart_drawer') === 'true') {
    sessionStorage.removeItem('open_cart_drawer');
    window.addEventListener('load', function() {
      setTimeout(function() {
        var trigger = document.querySelector('[data-testid="cart-drawer-trigger"]');
        if (trigger) trigger.click();
      }, 600);
    });
  }

  if (!isEdit || !lineKey) return;
  document.body.classList.add('cart-edit-mode');

  /* ============================================
   * Helper: get current cart state
   * ============================================ */
  function getCart() {
    return fetch('/cart.js', {
      method: 'GET',
      headers: { 'Content-Type': 'application/json' }
    }).then(function(r) { return r.json(); });
  }

  /* ============================================
   * Helper: find the line item to update
   * Try by key first, then by variant ID
   * ============================================ */
  function findLineItem(cart) {
    // Try exact key match
    for (var i = 0; i < cart.items.length; i++) {
      if (cart.items[i].key === lineKey) {
        return cart.items[i];
      }
    }
    // Fallback: find by original variant ID
    if (originalVariantId) {
      var vid = parseInt(originalVariantId);
      for (var j = 0; j < cart.items.length; j++) {
        if (cart.items[j].variant_id === vid) {
          return cart.items[j];
        }
      }
    }
    return null;
  }

  /* ============================================
   * Main update function
   * ============================================ */
  function updateCart(newVariantId, quantity, onDone, onError) {
    getCart().then(function(cart) {
      var item = findLineItem(cart);

      if (!item) {
        console.warn('[cart-edit] Item not found in cart, just adding new');
        return addItem(newVariantId, quantity);
      }

      var keyToRemove = item.key;
      var oldQuantity = item.quantity;
      var useQuantity = quantity || oldQuantity;

      // Check if this item has a bundle partner (frame)
      var bundleId = item.properties && item.properties._bundle_id;
      var frameKeyToRemove = null;

      if (bundleId) {
        for (var k = 0; k < cart.items.length; k++) {
          var ci = cart.items[k];
          if (ci.key === keyToRemove) continue;
          if (ci.properties && ci.properties._bundle_id === bundleId) {
            frameKeyToRemove = ci.key;
            break;
          }
        }
      }

      console.log('[cart-edit] Found item:', keyToRemove, 'qty:', oldQuantity);
      console.log('[cart-edit] Bundle frame key:', frameKeyToRemove);
      console.log('[cart-edit] New variant:', newVariantId, 'qty:', useQuantity);

      if (item.variant_id === parseInt(newVariantId) && useQuantity === oldQuantity) {
        console.log('[cart-edit] No changes, going back');
        goBack();
        return;
      }

      // Step 1: Remove old poster
      console.log('[cart-edit] Removing poster:', keyToRemove);
      return fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: keyToRemove, quantity: 0 })
      })
      .then(function(r) { return r.json(); })
      .then(function() {
        // Step 2: Remove old frame if exists
        if (frameKeyToRemove) {
          console.log('[cart-edit] Removing frame:', frameKeyToRemove);
          return fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: frameKeyToRemove, quantity: 0 })
          }).then(function(r) { return r.json(); });
        }
      })
      .then(function() {
        // Step 3: Add new item (bundle interception will handle frame if needed)
        console.log('[cart-edit] Adding:', newVariantId);
        return addItem(newVariantId, useQuantity);
      });
    })
    .then(function() {
      if (onDone) onDone();
      // goBack();
    })
    .catch(function(err) {
      console.error('[cart-edit] Error:', err);
      if (onError) onError();
    });
  }

  function addItem(variantId, quantity) {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        items: [{ id: parseInt(variantId), quantity: parseInt(quantity) || 1 }]
      })
    }).then(function(r) { return r.json(); });
  }

  function goBack() {
    sessionStorage.setItem('open_cart_drawer', 'true');
    // Use history.back, but fallback to cart page if no history
    if (window.history.length > 1) {
      window.history.back();
    } else {
      window.location.href = '/';
    }
  }

  /* ============================================
   * UI Setup
   * ============================================ */
  function init() {
    var form = document.querySelector('[data-type="add-to-cart-form"]');
    if (!form) { setTimeout(init, 300); return; }
    if (form.getAttribute('data-edit-bound')) return;
    form.setAttribute('data-edit-bound', '1');

    // ---- Neutralize form ----
    form.removeAttribute('action');
    form.setAttribute('onsubmit', 'return false;');

    var component = document.querySelector('product-form-component');
    if (component) {
      component.handleSubmit = function(e) {
        if (e && e.preventDefault) e.preventDefault();
        if (e && e.stopImmediatePropagation) e.stopImmediatePropagation();
        return false;
      };
    }

    // ---- Replace button ----
    var originalBtn = form.querySelector('button[type="submit"], .add-to-cart-button');
    if (!originalBtn) return;

    var newBtn = document.createElement('button');
    newBtn.type = 'button';
    newBtn.className = originalBtn.className;
    newBtn.textContent = 'Save changes';

    originalBtn.style.display = 'none';
    originalBtn.parentNode.insertBefore(newBtn, originalBtn.nextSibling);

    // ---- Click handler ----
    newBtn.addEventListener('click', function() {
      var variantId = form.querySelector('input[name="id"]').value;
      var qtyInput = form.querySelector('input[name="quantity"]');
      var qty = qtyInput ? parseInt(qtyInput.value) || 1 : 1;

      newBtn.disabled = true;
      newBtn.textContent = 'Saving...';

      updateCart(
        variantId,
        qty,
        function() {
          // Wait for bundle interception to finish adding frame
          var waitForBundle = setInterval(function() {
            if (!window.__vdBundleAdding) {
              clearInterval(waitForBundle);
              goBack();
            }
          }, 200);
          // Safety timeout: go back after 5s regardless
          setTimeout(function() {
            clearInterval(waitForBundle);
            goBack();
          }, 5000);
        },
        function() {
          newBtn.disabled = false;
          newBtn.textContent = 'Save changes';
        }
      );
    });

    // ---- Hide extras ----
    document.querySelectorAll(
      '.shopify-payment-button, shopify-accelerated-checkout, [data-shopify="dynamic-checkout"]'
    ).forEach(function(el) { el.style.display = 'none'; });

    var sticky = document.querySelector('sticky-add-to-cart');
    if (sticky) sticky.style.display = 'none';
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() { setTimeout(init, 100); });
  } else {
    setTimeout(init, 100);
  }
})();